import React, { useState, useEffect } from "react";
import api from "./api";

const UserProfile = () => {
  const storedUser = JSON.parse(localStorage.getItem("user")) || {};
  const [form, setForm] = useState({
    first_name: storedUser.first_name || "",
    last_name: storedUser.last_name || "",
  });

  const [passwordForm, setPasswordForm] = useState({
    current_password: "",
    new_password: "",
    new_password_confirmation: "",
  });

  const [message, setMessage] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");
  const [error, setError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.put("/user/profile", form);
      setMessage("✅ Profil zaktualizowany.");
      setError("");
      localStorage.setItem("user", JSON.stringify(res.data.user));
      setTimeout(() => setMessage(""), 4000);
    } catch (err) {
      setError("❌ Nie udało się zapisać profilu.");
      setMessage("");
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put("/user/password", {
      current_password: passwordForm.current_password,
      new_password: passwordForm.new_password,
      new_password_confirmation: passwordForm.new_password_confirmation,
    });
    setPasswordMessage("✅ Hasło zostało zmienione. Nastąpi wylogowanie...");
    setPasswordError("");
    setPasswordForm({
      current_password: "",
      new_password: "",
      new_password_confirmation: "",
    });
    setTimeout(() => {
      localStorage.clear();
      window.location.href = "/login";
    }, 2000);

    } catch (err) {
      setPasswordError(err.response?.data?.message || "❌ Błąd zmiany hasła.");
      setPasswordMessage("");
    }
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4">👤 Mój profil</h2>

      {/* Edycja profilu */}
      <form onSubmit={handleProfileSubmit} className="mb-5">
        <h5>Dane użytkownika</h5>
        {message && <div className="alert alert-success">{message}</div>}
        {error && <div className="alert alert-danger">{error}</div>}

        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Imię</label>
            <input
              type="text"
              className="form-control"
              value={form.first_name}
              onChange={(e) => setForm({ ...form, first_name: e.target.value })}
              required
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Nazwisko</label>
            <input
              type="text"
              className="form-control"
              value={form.last_name}
              onChange={(e) => setForm({ ...form, last_name: e.target.value })}
              required
            />
          </div>
          <div className="col-md-12">
            <label className="form-label">Email (tylko do odczytu)</label>
            <input type="email" className="form-control" value={storedUser.email} readOnly />
          </div>
        </div>

        <div className="mt-4 d-flex justify-content-end">
          <button className="btn btn-primary" type="submit">
            💾 Zapisz zmiany
          </button>
        </div>
      </form>

      {/* Zmiana hasła */}
      <form onSubmit={handlePasswordSubmit}>
        <h5>Zmiana hasła</h5>
        {passwordMessage && <div className="alert alert-success">{passwordMessage}</div>}
        {passwordError && <div className="alert alert-danger">{passwordError}</div>}

        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Obecne hasło</label>
            <input
              type="password"
              className="form-control"
              value={passwordForm.current_password}
              onChange={(e) => setPasswordForm({ ...passwordForm, current_password: e.target.value })}
              required
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Nowe hasło</label>
            <input
              type="password"
              className="form-control"
              value={passwordForm.new_password}
              onChange={(e) => setPasswordForm({ ...passwordForm, new_password: e.target.value })}
              required
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Powtórz nowe hasło</label>
            <input
              type="password"
              className="form-control"
              value={passwordForm.new_password_confirmation}
              onChange={(e) =>
                setPasswordForm({ ...passwordForm, new_password_confirmation: e.target.value })
              }
              required
            />
          </div>
        </div>

        <div className="mt-4 d-flex justify-content-end">
          <button className="btn btn-warning" type="submit">
            🔐 Zmień hasło
          </button>
        </div>
      </form>
    </div>
  );
};

export default UserProfile;
